import { Grid } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const BuscarPacienteFilters = ({
    filters,
    handleSearch,
    handleChangeFilters,
    disableFilters
}) => {

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ xs: 12, md: 6, lg: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'string',
                        displayName: 'Nombre',
                        name: 'nombre',
                        key: `${filters?.nombre}-nombre`,
                        disabled: disableFilters
                    }}
                    value={filters.nombre}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'string',
                        displayName: 'Apellido',
                        name: 'apellido',
                        key: `${filters?.apellido}-apellido`,
                        disabled: disableFilters
                    }}
                    value={filters.apellido}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, md: 6, lg: 1.5, xl: 1.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'string',
                        displayName: 'Código SAP',
                        name: 'codigoSap',
                        disabled: disableFilters
                    }}
                    value={filters.codigoSap}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, md: 6, lg: 1.5, xl: 1.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'string',
                        displayName: 'DNI',
                        name: 'dni',
                        disabled: disableFilters
                    }}
                    value={filters.dni}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, md: 6, lg: 1.5, xl: 1.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'string',
                        displayName: 'N° de Afiliado',
                        name: 'afiliado',
                        disabled: disableFilters
                    }}
                    value={filters.afiliado}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ xs: 6, sm: 6, md: 12, lg: 2.5, xl: 2.5 }}>
                <CustomButton
                    variant='contained'
                    onClick={() => handleSearch()}
                    size='small'
                    disabled={disableFilters}
                >
                    Buscar
                </CustomButton>
            </Grid>
        </Grid>
    )
}